import React from 'react';
import { BaselineContainer, BaselineOption, BaselineText } from './Baseline.styles';

const Baseline = ({ disabled = false, onChange, value }) => {
  return  (
    <BaselineContainer>
      <BaselineOption bgColor="#008000"><BaselineText>happy</BaselineText></BaselineOption>
      <BaselineOption bgColor="#F6BE00"><BaselineText>concern</BaselineText></BaselineOption>
      <BaselineOption bgColor="#8B0000"><BaselineText>alert</BaselineText></BaselineOption>
    </BaselineContainer>
  );
};

export default Baseline;